import { ReelAnimateTime } from '@/bundle/shared/components/ReelAnimateTime/ReelAnimateTime';
import { ButtonNew } from '@/components-new/ButtonNew/ButtonNew';
import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { useTimer } from '@/hooks/useTimer';
import { useState } from 'react';

type RecipientRequestVerificationInProgressType = {
  phone: string;
  isLoading: boolean;
  canResend: boolean;
  onResend: () => void;
  onChangeNumber: () => void;
  resendIn: number;
  onTimerEnds: () => void;
};

export const RecipientRequestVerificationInProgress = ({
  phone,
  isLoading,
  onResend,
  resendIn,
  onChangeNumber,
  canResend,
  onTimerEnds,
}: RecipientRequestVerificationInProgressType) => {
  const [seed] = useState(resendIn);
  const { seconds } = useTimer(seed, onTimerEnds);
  const waiting = resendIn > 0;

  return (
    <Box display='flex' flexDirection='column' rowGap='20px'>
      <Typography variant='bodySmall'>
        Check your phone <strong>{phone}</strong> for a text message from TrustStamp and complete the steps. This page
        updates on its own.
      </Typography>
      <ButtonNew variant='primary' disabled={waiting || !canResend} isLoading={isLoading} onClick={onResend}>
        {resendIn > 0 ? (
          <>
            Resend in &nbsp; <ReelAnimateTime seconds={seconds} />
          </>
        ) : (
          'Resend verification link'
        )}
      </ButtonNew>
      {!waiting && (
        <ButtonNew variant='secondary' onClick={onChangeNumber}>
          Use a different number
        </ButtonNew>
      )}
    </Box>
  );
};
